/** "The user's exchange connections changed" — fired after a successful bot
 * start or connection delete so views that keep their OWN copy of the
 * connection list (the header's exchange picker, `usePortalHeader`) reload it
 * instead of showing the old entries until a full page reload. */
export const CONNECTIONS_CHANGED_EVENT = 'grabbitbot:connections-changed'

export function notifyConnectionsChanged(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(CONNECTIONS_CHANGED_EVENT))
}
